import React from "react";
import DOMPurify from "isomorphic-dompurify";

const Typography = (props: any) => {
  const { text, selfPiText, isSelfPi, type, styles, is_visible } = props;

  return is_visible? (
    <div className="image-heading-container">
      {isSelfPi ? (
        <div
          className="text-container"
          style={styles}
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(selfPiText) }}
        ></div>
      ) : (
        <div
          className="text-container"
          style={styles}
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }}
        ></div>
      )}
      <style jsx>{`
        .image-heading-container {
        }
        .text-container {
          color: #040222;
          text-align: center;
          font-size: 20px;
          font-weight: 600;
          line-height: 28px;
          letter-spacing: -0.1px;
          margin: 24px 0px;
          width: 426px;
        }
        @media (max-width: 768px) {
          .text-container {
            width: 100%;
            text-align: left;
          }
        }
      `}</style>
    </div>
  ) : null;
};

export default Typography;
